export default __webpack_public_path__ + "static/media/image-37.0adeca30.png";